const ProfileIcon = ({ ...props }) => {
	return (
		<svg
			{...props}
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.75 6.5C12.75 8.15685 11.5188 9.5 10 9.5C8.48122 9.5 7.25 8.15685 7.25 6.5C7.25 4.84315 8.48122 3.5 10 3.5C11.5188 3.5 12.75 4.84315 12.75 6.5Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.50065 17.6001C1.35795 15.7661 0 13.0416 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 13.0416 18.6421 15.7661 16.4993 17.6001C14.7514 19.0963 12.4812 20 10 20C7.58375 20 5.36766 19.143 3.63907 17.7165C3.59258 17.6781 3.54644 17.6393 3.50065 17.6001ZM16.1239 15.1479C17.2947 13.7566 18 11.9606 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 11.9606 2.70532 13.7566 3.87607 15.1479C4.7733 12.4389 7.17639 10.5 10 10.5C12.8236 10.5 15.2267 12.4389 16.1239 15.1479Z"
				fill="currentColor"
			/>
		</svg>
	)
}

export default ProfileIcon
